import mapboxgl from 'mapbox-gl';

export function configureMapboxWorker(): void {
  if (typeof Worker === 'undefined' || mapboxgl.workerClass) {
    return;
  }

  mapboxgl.workerClass = class {
    constructor() {
      // Must stay inline so Angular emits a real worker chunk.
      return new Worker(new URL('./mapbox-gl-csp.worker', import.meta.url), {
        type: 'module',
      });
    }
  } as unknown as typeof mapboxgl.workerClass;
}
